<section id="dacSpeakers-id" class="dac-speakers" *ngIf="(serviceList$ | async)?.length">
  <div class="box">
    <h2 class="box-title"><span>Speakers</span></h2>
    <div class="box-speaker">
      <ng-container *ngFor="let item of serviceList$ | async">
        <div class="box-speaker__list">
          <img [src]="item.data.image.iv" [alt]="item.data.name.iv" loading="lazy" class="box-speaker__list--image" />
          <div class="box-speaker__list--name"><span [innerHTML]="item.data.name.iv"></span></div>
          <div class="box-speaker__list--position"
            ><span>{{ item.data.position.iv }}</span></div
          >
        </div>
      </ng-container>
    </div>
  </div>
</section>
